import { render, staticRenderFns } from "./TheMenuDesktop.vue?vue&type=template&id=6bdd2530&scoped=true&"
import script from "./TheMenuDesktop.vue?vue&type=script&lang=js&"
export * from "./TheMenuDesktop.vue?vue&type=script&lang=js&"
import style0 from "./TheMenuDesktop.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TheMenuDesktop.vue?vue&type=style&index=1&id=6bdd2530&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdd2530",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VList,VNavigationDrawer})
